import { render, staticRenderFns } from "./ProblemRecord.vue?vue&type=template&id=7827b56a&scoped=true"
import script from "./ProblemRecord.vue?vue&type=script&lang=js"
export * from "./ProblemRecord.vue?vue&type=script&lang=js"
import style0 from "./ProblemRecord.vue?vue&type=style&index=0&id=7827b56a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7827b56a",
  null
  
)

export default component.exports